module.exports = __webpack_public_path__ + "img/diamond-grey.48f2c6a5.svg";